import { overlay } from 'overlay-kit';
import { QuizSetupModal, type QuizSetupModalProps } from './components';
export { useShowQuizSetupModal } from './hooks';

// ============================================================================
// Modal wrapper (기존 코드 호환성을 위한 export)
// ============================================================================

/**
 * 신규 퀴즈 생성 모달 오픈 (overlay-kit)
 *
 * 설정을 끝냈으면 `true`, 그냥 닫았으면 `false` 로 resolve 한다.
 * `overlay.openAsync` 는 **`close(value)` 로만** resolve 되므로 `unmount()` 만
 * 부르면 호출부의 `await` 가 영영 걸린 채 남아 완료 후처리가 실행되지 않는다.
 */
export const quizSetupModal = {
  openAsync({
    mapTemplates,
    selectedMapTemplateId,
    initialCategoryInfoValues,
    schoolInfoTree,
    subjectTree,
    publishers,
    userCountryCode,
    quizBankExposedCategoryPrefixes,
    buildType,
    quizBankRemainingSlots,
    quizBankAddedProblemIds,
    onMapComplete,
    onCategoryInfoComplete,
    onQuizBankComplete
  }: QuizSetupModalProps) {
    return overlay.openAsync<boolean>(({
      close,
      unmount
    }) => {
      const settle = (completed: boolean) => {
        close(completed);
        unmount();
      };
      return <QuizSetupModal mapTemplates={mapTemplates} selectedMapTemplateId={selectedMapTemplateId} initialCategoryInfoValues={initialCategoryInfoValues} schoolInfoTree={schoolInfoTree} subjectTree={subjectTree} publishers={publishers} userCountryCode={userCountryCode} quizBankExposedCategoryPrefixes={quizBankExposedCategoryPrefixes} buildType={buildType} quizBankRemainingSlots={quizBankRemainingSlots} quizBankAddedProblemIds={quizBankAddedProblemIds} onMapComplete={onMapComplete} onCategoryInfoComplete={onCategoryInfoComplete} onQuizBankComplete={problems => {
        onQuizBankComplete(problems);
        settle(true);
      }} onClose={() => settle(false)} />;
    });
  }
};